<template>
  <div class="gallery-main">
    <media-list
      v-if="mediaItems"
      :server-items="mediaItems"
      :categories="categories"
      :options="options"
      :limit-overwrite="Number(options.MediaItemsPerLoadMore)"
    ></media-list>
  </div>
</template>

<script>
import MediaList from './gallery-list';

export default {
  name: 'gallery',
  components: {
    MediaList
  },
  props: {
    mediaData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    videoPlayerDictionary: {
      type: Object,
      required: true,
      default: () => ({})
    },
    options: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      categories: [],
      mediaItems: [],
      galleryType: 'property',
    }
  },
  provide() {
    return {
      videoPlayerDictionary: this.videoPlayerDictionary
    }
  },
  created() {
      this.getGalleryData();
  },
  mounted() {
       document.querySelector('body').style.overflowY = 'scroll';
  },
  methods: {
    getGalleryData(){
      this.categories = this.mediaData.Categories;
      this.mediaItems = this.mediaData.Assets;
    },
  }
};
</script>

